import React, { useState, useEffect, useMemo } from "react";
import { FeedbackConfig } from "../../pages";
import { toJS } from "mobx";
import { feedbackStore } from "../../stores";
import { FeedbackController } from "../../controllers";

const FeedbackConfigContainer = () => {
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [openConfigModal, setOpenConfigModal] = useState(false);
  const [activationModal, setActivationModal] = useState(false);
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const feedbackConfigTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } = FeedbackController.useGetFeedbackKey(
    feedbackConfigTableQuery,
    filterQuery,
    searchQuery
  );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const closeModal = () => {
    setOpenConfigModal(false);
    setActivationModal(false);
  };

  const filterHandler = async (query) => {
    setLoading2(true);
    setFilterQuery(query);
    setLoading2(false);
  };
  return (
    <FeedbackConfig
      filterHandler={filterHandler}
      loading2={loading2}
      loading={loading}
      closeModal={closeModal}
      openConfigModal={openConfigModal}
      setOpenConfigModal={setOpenConfigModal}
      activationModal={activationModal}
      setActivationModal={setActivationModal}
      isLoading={isLoading}
      feedbackConfigData={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
    />
  );
};

export default FeedbackConfigContainer;
